import type { FaireProductEntity } from "../../entity_types/product";

export const p_enwq9pr3q4: FaireProductEntity = {
  token: "p_enwq9pr3q4",
  type: "product",
  name: "Cotton Grand Canyon Tribal Pant D1355",
  brandToken: "b_1ebsymwkg7",
  brandName: "Rising International Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/ed96b62ecf910585379028514de81c44a653916d415593e7e7ab0246036d005a.jpeg",
  galleryImageUrls: [],
  priceDollars: 17,
  description:
    "Cotton Xo Multi Patchwork Block Print Grand Canyon Tribal Pant\nPre Packed of 4 Pcs  S M L XL ",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:36.143Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
